import { FC, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { getInitialAbbreviation } from "helpers";
import { logout } from "toolkit/profile/profile.slice";
import { ReactComponent as ProfileIcon } from "images/profile.svg";
import { ReactComponent as ExitIcon } from "images/exit.svg";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import cn from "classnames";
import styles from "./ProfilePopup.module.sass";
import { BUTTON_VARIANTS } from "../shared/Button/Button";
import { changeEditMode, changeVisibleComments } from "../../toolkit/comments/comments.slice";
import { Button } from "../shared";

interface InitialProps {
	active: boolean;
	fullName: string;
	handleActive: () => void;
}

const Initial: FC<InitialProps> = ({ active, fullName, handleActive }) => {
	return (
		<div className={cn(styles.initial, { [styles.active]: active })} onClick={handleActive}>
			{getInitialAbbreviation(fullName)}
		</div>
	);
};

const ProfilePopup: FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const { profile } = useAppSelector((state) => state.profile);

	const { visible, editMode } = useAppSelector((state) => state.comments);

	const popupRef = useRef<HTMLDivElement | null>(null);

	const [active, setActive] = useState<boolean>(false);

	useOutsideAlerter(popupRef.current, () => setActive(false));

	const fullName = useMemo(() => {
		return `${profile.lastName} ${profile.firstName} ${profile.middleName}`;
	}, [profile]);

	const redirectProfile = () => {
		navigate(`/user/${profile.id}`);
		setActive(false);
	};

	const exit = () => {
		dispatch(logout());
		setActive(false);
	};

	return (
		<div data-comment-false={true} className={styles.profile} ref={popupRef}>
			<Button
				data-comment-false={true}
				onMouseDown={(e) => {
					e.stopPropagation();
					e.preventDefault();
					dispatch(changeVisibleComments());
				}}
				variant={BUTTON_VARIANTS.TEXT}>
				<div className={styles.visibleIcon} />
				{visible ? "Скрыть подсказки" : "Показать подсказки"}
			</Button>
			{profile.admin && visible && (
				<div>
					<div
						onMouseDown={(e) => {
							e.stopPropagation();
							e.preventDefault();
							dispatch(changeEditMode());
						}}
						className={cn(styles.editMode, editMode ? styles.editMode__active : styles.editMode__disable)}
					/>
				</div>
			)}
			{active ? (
				<div className={styles.profilePopup}>
					<Initial active={active} fullName={fullName} handleActive={() => setActive((prevState) => !prevState)} />
					<div className={styles.fullName}>{fullName}</div>
					<div className={styles.position}>{profile.position}</div>

					<div className={styles.btn} onClick={redirectProfile}>
						<div>
							<ProfileIcon />
						</div>
						Профиль
					</div>

					<div className={styles.btn} onClick={exit}>
						<div>
							<ExitIcon />
						</div>
						Выйти
					</div>
				</div>
			) : (
				<Initial active={active} fullName={fullName} handleActive={() => setActive((prevState) => !prevState)} />
			)}
		</div>
	);
};

export default ProfilePopup;
